import { defaultLanguage } from '@/i18n'
import { HTTP } from '@/http-common'
import Vue from 'vue'

const getDefaultState = () => {
    return {
        language: defaultLanguage,
        loading: true,
        activeRoute: null,
        formStarted: false,
        metadata: {
            campID: '',
            channel: '',
            aecID: ''
        },
        consent: {
            id: '',
            title: '',
            content: '',
            display: false,
            links: [],
            confirmLabel: '',
            confirmText: '',
            confirmMandatory: false
        }
    }
}

// initial state
const state = getDefaultState()

// getters
const getters = {
    language: (state) => state.language,
    country: (state) => state.country,
    consent: (state) => state.consent
}

// mutations
const mutations = {
    mutate: (state, payload) => {
        for (const property in payload) {
            if (payload.hasOwnProperty(property)) {
                Vue.set(state, property, payload[property])
            }
        }
    },
    setLanguage: (state, language) => {
        state.language = language
    },
    setCountry: (state, country) => {
        state.country = country
    },
    setConsent: (state, payload) => {
        state.consent = payload
    },
    setMetadata: (state, payload) => {
        state.metadata = {
            ...state.metadata,
            ...payload
        }
    },
    setLoading: (state, loading) => {
        state.loading = loading
    }
}

// actions
const actions = {
    set: ({ commit }, payload) => {
        commit('mutate', payload)
    },
    changeLanguage: (context, language) => {
        context.commit('setLanguage', language)
    },
    changeCountry: (context, country) => {
        context.commit('setCountry', country)
    },
    loadConsent: async ({ commit, state }, { formType }) => {
        const payload = {
            language: state.language,
            formType
        }

        try {
            const response = await HTTP.post('/consent', payload)
            commit('setConsent', response.data)
        } catch (error) {
            console.log('loadConsent() catch()', error.message)
        }
    },
    setMetadata: ({ commit }, payload) => {
        commit('setMetadata', payload)
    },
    resetData: (context) => {
        context.dispatch('question/resetState', {}, { root: true })
        context.dispatch('userdata/resetState', {}, { root: true })
    },
    setLoading: (context, loading) => {
        context.commit('setLoading', loading)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
